import DayJS from 'dayjs';
DayJS.locale('ja');

export const dayjs = DayJS;
